export const namespace = 'canalplus.block.oneshop.unauthenticated_renewal';
export { default as Component } from './components/Form';
export { default as propsFormatter } from './propsFormatter';
